import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=37f8bded&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f8bded')) {
      api.createRecord('37f8bded', component.options)
    } else {
      api.reload('37f8bded', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=37f8bded&", function () {
      api.rerender('37f8bded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J6W0v6xZznwA/JS/videoIframe.vue"
export default component.exports